// @flow
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import Slider from 'react-slick';
import { EventCardMobile } from 'components/molecules/eventCardMobile';
import type { ProjectAnnouncement } from 'types/project';

type Props = {
  announcements: Array<ProjectAnnouncement>,
};

const ProjectAnnouncementsMobileCarousel = (props: Props) => {
  const [viewport, setViewport] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    updateViewport();
    window.addEventListener('resize', updateViewport);
    return () => {
      window.removeEventListener('resize', updateViewport);
    };
  }, []);

  const updateViewport = () => {
    setViewport({
      ...viewport,
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const { announcements, onGetInTouchClick, checkForCTAButton } = props;
  if (!announcements || announcements.length === 0) {
    return null;
  }

  const onProjectAnnouncementCardClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (urlSlug) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(props, redirectionURl);
      } else {
        window.location.assign(`${redirectionURl}`);
      }
    }
  };

  const checkAnnouncementURL = urlSlug => {
    if (checkForCTAButton === true && !urlSlug) onGetInTouchClick(true);
    else onProjectAnnouncementCardClick(urlSlug);
  };

  const settings = {
    className: 'slider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
  };

  return (
    <div className="theme">
      <Slider {...settings}>
        {announcements.map((announcement: ProjectAnnouncement) => {
          return (
            <EventCardMobile
              data={{
                title: announcement.title,
                subTitle: announcement.description,
                imageUrl: announcement.mobileImageUrl,
              }}
              onClick={() => checkAnnouncementURL(announcement.urlSlug)}
              key={announcement.id}
              from={'announcements'}
              ctaText={
                checkForCTAButton === true && !announcement.urlSlug
                  ? 'GET IN TOUCH'
                  : 'EXPLORE'
              }
            />
          );
        })}
      </Slider>
    </div>
  );
};

export default withRouter(ProjectAnnouncementsMobileCarousel);
